var _path, _line, _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrowserVersionIcon = function SvgBrowserVersionIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21c-4.971 0-9-4.029-9-9 0-4.971 4.029-9 9-9 4.971 0 9 4.029 9 9",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    fillRule: "evenodd",
    stroke: "#AEAEB2",
    fill: "none",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.51,
    x2: 20.49,
    y1: 9,
    y2: 9,
    fill: "none",
    stroke: "#AEAEB2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 1.5,
    stroke: "#AEAEB2",
    fill: "none",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 3.51,
    x2: 12,
    y1: 15,
    y2: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 22l-1.863-1.863"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 15c1.657 0 3 1.343 3 3 0 1.657-1.343 3-3 3 -1.657 0-3-1.343-3-3 0-1.657 1.343-3 3-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 12c0-2.764-.723-5.528-2.167-7.94 -.847-1.413-2.819-1.413-3.665 0 -2.89 4.825-2.89 11.056 0 15.881 .423.706 1.128 1.06 1.833 1.06"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })));
};
export { SvgBrowserVersionIcon as ReactComponent };
export default __webpack_public_path__ + "browser-version-icon.svg";